<!--
 * @Description: 酒店列表
 * @Author: wjh
 * @Date: 2021-3
 * @LastEditors: wjh
 -->
<template>
    <div id="hotelList">
        <Loading v-if="show"></Loading>
        <div class="hotelList_container">
            <header class="hotel-header">
                <div class="header-left">
                    <!-- <img src="../../assets/return.png"> --> 
                </div>
                <div class="header-title">
                    酒店预定
                </div>
                <div class="header-right">
                    
                </div>
            </header>
            <div class="hotelList_content"  v-if="hotelInfo!=null && hotelInfo.length>0">
                <div class="hotel-list" 
                    v-for="(item,index) in hotelInfo"  :key='index'>
                    <div class="hotel-img">
                        <img v-if="item.hotelpic==''||item.hotelpic==null||!item.hotelpic" src="../../assets/hotel.png">
                        <img v-else :src="item.hotelpic">
                    </div>
                    <div class="hotel-con">
                        <div class="hotel-name">
                            {{item.hotellname}}
                        </div>
                        <div class="hotel-desc">
                            距离会场直线距离{{item.venuedistance}}米
                        </div>
                        <div class="hotel-money">
                            <span>￥<i>{{item.money}}</i></span> 起
                        </div>
                        <div class="hotel-btn">
                            <span v-if="!configEntity.btncontent" @click="goDetail($event,item.hotelid)">立即预定</span>
                            <span v-else><a :href="configEntity.btnlink" target="_top">{{configEntity.btncontent}}</a></span>
                        </div>
                    </div>
                </div>
                <div class="loading" v-if="loading">
                    <van-loading type="spinner" color="#3b82f6" vertical size="30px" text-size="14px">加载中...</van-loading>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Loading from '@components/Loading.vue'
import Footer from '@components/Footer.vue'
import publicSignup from '../../lib/signUp.js'
import wxShare from '../../lib/wxShare.js'

export default {
    name: 'hotelList',
    components: {
        Loading,
    },
    data() {
        return {
          publicSignup: {}, //通用js
          params: {
              m: '',
              red: '',
          },
          meetingInfo: '',
          show: false,
          loading: false,
          hotelInfo: [],
          red: '',
          navShow: true,
          navhomeUrl: '',
          configEntity: '',
        }
    },
    created() {
        this.params = this.$route.query
        this.red = this.params.red
        this.publicSignup = new publicSignup()
        //console.log(this.publicSignup)
        let opt = { m: this.params.m }
        this.initmeeting(opt)
        this.hotelHomePage(opt)
    },
    mounted() {
        //this.swiperInit()
    },
    methods: {
        async initmeeting(opt) {
            this.show = true
            this.meetingInfo = await this.publicSignup.init(opt, this)
            if (this.meetingInfo.Code === 1000) {
                this.show = false
                if (this.meetingInfo.HomeUrl == null || this.meetingInfo.HomeUrl == '') {
                    this.navShow = false
                } else {
                    this.navShow = true
                    this.navhomeUrl = this.meetingInfo.HomeUrl
                }
                document.title = this.meetingInfo.MeetingTitle
                this.$emit('homeFun',this.meetingInfo.HomeUrl)
                this.$emit('logoFun',this.meetingInfo.isshowlogo)
				this.$emit('meetinginfo',this.meetingInfo)
            } else {
                this.$notify({
                    massage: this.meetingInfo.Msg,
                    type: 'danger',
                    duration: '3000',
                })
            }
        },
        /**
         * 初始化报名用户数据
         */
        async hotelHomePage(opt) {
            try {
                this.loading = true
                let res = await this.$http.hotelHomePage(opt)
                console.log(res)
                if (res.Code === 1000) {
                    this.loading = false
                    this.hotelInfo = res.hotel_BasicinfoEntities
                    this.configEntity = res.hotel_Resv_ConfigEntity
                } else {
                    this.$notify({
                        message: res.Msg,
                        type: 'primary',
                    })
                }
            } catch (err) {
                console.log(err)
            }
        },

        //微信分享
        async initShare(title, desc, link, imgUrl) {
            try {
                const headRes = await this.$http.csData({
                    url: encodeURIComponent(
                        window.location.href.replace(location.hash, '')
                    ),
                })
                console.log(headRes, 'headRes')
                const _Wx = new wxShare({
                    opt: headRes,
                })
                _Wx.ready().then((wx) => {
                  _Wx.share(title, desc, link, imgUrl)
                  console.log(wx)
                })
                //this.headRess = _Wx
            } catch (err) {
                console.log(err)
            }
        },

        goDetail(e,hotelid){
            const params = {
                m: this.params.m,
                hotelid: hotelid,
            }
            const { m } = this.$route.query
			console.log(m)
            this.$router.push({
                path: '/hotelDetail',
                query: { m, ...params },
            })
        },
    },
}
</script>
<style lang="scss" scoped>
    .hotel-header{
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 80px;
        background: #fffffffff;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #e2e8f0;
        .header-left,
        .header-right{
            width: 100px;
            text-align: center;
            img{
                width: 40px;
                height: 40px;
            }
        }
        .header-title{
            flex: 1;
            text-align: center;
            font-size: 30px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
    }
    .hotelList_content{
        padding: 80px 0 20px;
        .hotel-list{
            position: relative;
            display: flex;
            padding: 15px;
            background: #fffffffff;
            margin-top: 20px;
            border-bottom: 1px solid #e2e8f0;
            .hotel-img{
                position: absolute;
                left: 15px;
                top: 15px;
                bottom: 15px;
                width: 250px;
                border-radius: 10px;
                border: 1px solid #e2e8f0;
                overflow: hidden;
                img{
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }
            .hotel-con{
                width: 100%;
                padding-left: 270px;
                padding-top: 20px;
                .hotel-name{
                    font-size: 30px;
                    color: #1e293b;
                    font-weight: bold;
                }
                .hotel-desc{
                    font-size: 28px;
                    color: #1e293b;
                    margin-top: 5px;
                }
                .hotel-money{
                    text-align: right;
                    color: #1e293b;
                    padding-right: 15px;
                    font-size: 28px;
                    span{
                        color: #e6a23c;
                        font-weight: bold;
                        i{
                            font-size: 40px;
                        }
                    }
                }
                .hotel-btn{
                    height: 40px;
                    background-image: linear-gradient(135deg, #3b82f6, #6366f1);
                    color: #fff;
                    text-align: center;
                    line-height: 40px;
                    border-radius: 20px;
                    float: right;
                    margin-top: 5px;
                    padding: 0 20px;
                    span{
                        display: block;
                        float: left;
                        width: 100%;
                        text-align: center;
                        box-sizing: border-box;
                        a{
                            color: #fff;
                        }
                    }
                    // span:first-child{
                    //     border-right: 1px dashed #fff;
                    // }
                }
            }
        }
    }
</style>
<style type="text/css">
    #app{
        background: #ffffff;
    }
</style>